import * as Yup from 'yup';

export const moderatorSchema = Yup.object().shape({
  title: Yup.string().required('title'),
  firstName: Yup.string().required('firstName'),
  lastName: Yup.string().required('lastName'),
  email: Yup.string().email('Invalid email').required('email')
});
